<template>
  <div>
    <!-- Search筛选 -->
    <el-form :inline="true" :model="params" class="business-search">
      <el-form-item label="">
        <el-input size="small" v-model="params.name" placeholder="Name" clearable></el-input>
      </el-form-item>
      <el-select size="small" v-model="params.country" clearable placeholder="Country"
        style="width:140px;position:relative;top: 5px;right:5px">
        <el-option v-for="item in countryList" :key="item.name" :label="item.name" :value="item.name">
        </el-option>
      </el-select>
      <el-cascader :options="operatorList" size="small"
        :props="{ checkStrictly: true,value:'id',label:'name',expandTrigger: 'hover'}" clearable
        placeholder="Select Operator" @change="operatorParamsChange" style="position:relative;top: 5px;right:5px">
      </el-cascader>
      <el-form-item label="">
        <el-input size="small" v-model="params.sms_user_name" placeholder="App name" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="params.card_number" placeholder="Card number" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">Search</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" :highlight-current-row="false" v-loading="loading"
      element-loading-text="Loading..." style="width: 1562px">
      <el-table-column prop="name" label="Name" width="140" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.name}}</span>
          <span v-if="scope.row.agent_name" style="color:#909399">(Agent:{{scope.row.agent_name}})</span>
          <div>【{{scope.row.country}}】{{scope.row.description}}</div>
          <div>
            <el-link type="primary" icon="el-icon-edit" :underline="false" @click="setCard(scope.row)">
              Set SMS</el-link>
          </div>
          <div>
            {{scope.row.save_time|timestampToTime}}
          </div>
          <div><span style="color:#909399;display:block">SMS total balance：</span>{{scope.row.balance_total_amount}}
          </div>
          <div><span style="color:#909399;display:block">Cards in use：</span>{{scope.row.use_num}}
          </div>
          <div><span style="color:#909399;display:block">Cards disabled：</span>{{scope.row.use_not_num}}
          </div>
          <div v-if="scope.row.country=='Kenya'"><span style="color:#909399;display:block">Total limit
              amount：</span>{{scope.row.day_total_amount||0}}</div>
          <div v-if="scope.row.country=='Kenya'"><span style="color:#909399;">Cart
              nums：</span>{{scope.row.cart_nums}}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="card_id_nums" label="SIM card" align="center" width="1132">
        <template slot-scope="scope1">
          <el-table size="mini" :highlight-current-row="false" :data="scope1.row.card" v-loading="loading"
            style="width: 1112px;" v-if="scope1.row.card.length>0" :border="false">
            <el-table-column prop="sms_user_name" label="user" width="100" sortable="">
              <template slot-scope="scope2">
                <el-link type="success" :underline="false">{{scope2.row.sms_user_name}}</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="socket_id" label="on/off" sortable="" width="90">
              <template slot-scope="scope">
                <el-link type="success" :underline="false" v-if="scope.row.socket_id>0">online</el-link>
                <el-link type="danger" :underline="false" v-else>offline</el-link>
              </template>
            </el-table-column>
            <el-table-column align="center" label="operate" width="100">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="getAllMessage(scope.row.sms_user_id)">GETALL</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="is_top" label="SMS" width="682" align="center">
              <template slot-scope="scope2">
                <el-table size="mini" :highlight-current-row="false" :data="scope2.row.data" v-loading="loading"
                  style="width: 662px;" :border="false" :show-header="false">
                  <el-table-column prop="number" label="Card number" width="120" align="center" sortable>
                    <template slot-scope="scope">
                      <div>{{scope.row.number}}</div>
                      
                      <div>{{scope.row.operator_country=='Zimbabwe'?scope.row.name:scope.row.operator_name}}</div>
                      <div>
                        <el-link type="warning" icon="el-icon-edit"
                          @click="cardRemoved(scope.row.id,scope.row.number,scope.row.business_id)" :underline="false">
                          Remove</el-link>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="balance" label="卡余额" width="160" align="center">
                    <template slot-scope="scope">
                      <div style="font-size: 10px;" v-if="scope.row.operator_country=='Tanzania'&&scope.row.card_type==1">{{scope.row.name}}</div>
                      <div><span style="color:#909399">balance：</span><span
                          :style="{color:(scope.row.balance_amounts>50000000&&scope.row.operator_country=='Congo')||(scope.row.balance_amounts>2000000&&scope.row.operator_country=='Tanzania')?'#F56C6C':'#606266'}">{{scope.row.balance_amount}}</span>
                        <el-link type="primary" icon="el-icon-edit" :underline="false"
                          class="card-balance-edit" title="Edit balance" @click="openCardBalanceEdit(scope.row)">
                        </el-link>
                      </div>
                      <div v-if="scope.row.day_amount!='0.00'"><span style="color:#909399">limit
                          amount：</span><span
                          :style="{color:scope.row.day_amounts<10000&&scope.row.operator_country=='Kenya'?'#E6A23C':'#606266'}">{{scope.row.day_amount}}</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="balance" label="卡余额" width="200">
                    <template slot-scope="scope">
                      <div><span style="color:#909399">today R：</span>{{scope.row.today_reserved_amount}}</div>
                      <div><span style="color:#909399">today W：</span>{{scope.row.today_transaction_amount}}
                      </div>
                      <div><span style="color:#909399">month R：</span>{{scope.row.month_reserved_amount}}</div>
                      <div><span style="color:#909399">month W：</span>
                        <span style="color:#F56C6C"
                          v-if="scope.row.operator_country=='Zimbabwe'&&scope.row.month_transaction_amounts>950">{{scope.row.month_transaction_amount}}</span>
                        <span style="color:#606266" v-else>{{scope.row.month_transaction_amount}}</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="number" label="Card number" width="100" align="center" sortable>
                    <template slot-scope="scope">
                      <div>{{scope.row.card_type==1?'Agent line':'Personal line'}}</div>
                      <div>
                        <el-link type="info" icon="el-icon-edit"
                          @click="updateCardState(scope.row.id,scope.row.number,2)" :underline="false"
                          v-if="scope.row.state==1">using</el-link>
                        <el-link type="danger" icon="el-icon-edit"
                          @click="updateCardState(scope.row.id,scope.row.number,1)" :underline="false"
                          v-if="scope.row.state==2">disabled</el-link>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="Action" width="80">
                    <template slot-scope="scope">
                      <div class="caozuo_btn">
                        <div style="color:#F56C6C">{{scope.row.desc}}</div>
                      </div>
                      <div class="caozuo_btn">
                        <el-button size="mini" type="primary" @click="cardBalanceDetail(scope.row)">Detail
                        </el-button>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column align="center" label="Automatic" width="130">
              <template slot-scope="scope">
                <el-link type="success" icon="el-icon-edit" @click="updateAutoTrans(scope.row.sms_user_id,0)"
                  :underline="false" v-if="scope.row.auto_trans==1">open</el-link>
                <el-link type="danger" icon="el-icon-edit" @click="updateAutoTrans(scope.row.sms_user_id,1)"
                  :underline="false" v-if="scope.row.auto_trans==0">Manual close</el-link>
                <el-link type="danger" icon="el-icon-edit" @click="updateAutoTrans(scope.row.sms_user_id,1)"
                  :underline="false" v-if="scope.row.auto_trans==2">Auto close</el-link>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="Static" width="180">
        <template slot-scope="scope">
          <div>
            <span style="color:#909399;">status：</span>
            <el-link type="warning" :underline="false" v-if="scope.row.state==1">reviewed</el-link>
            <el-link type="info" :underline="false" v-if="scope.row.state==2">using</el-link>
            <el-link type="danger" :underline="false" v-if="scope.row.state==3">disabled</el-link>
          </div>
          <div><span style="color:#909399;display:block">Calculate total
              balance：</span>{{scope.row.cal_balance_total_amount}}
          </div>
          <div><span style="color:#909399;display:block">0 total balance：</span>{{scope.row.balance0_total_amount}}
          </div>
          <div><span style="color:#909399;display:block">Daily recharge：</span>{{scope.row.today_total_reserved_amount}}
          </div>
          <div><span style="color:#909399;display:block">Daily
              withdraw：</span>{{scope.row.today_total_transaction_amount}}</div>
              <div v-for="item in scope.row.operator_balance" :key="item">
                <span style="color:#909399;display:block">{{item.operator_name}}：</span>{{item.balance_amount+' | '+item.operator_bcount}}</div>
          <div class="caozuo_btn">
            <el-button size="mini" type="success" @click="changeAutomatic(scope.row,1)">Open All Automatic</el-button>
          </div>
          <div class="caozuo_btn">
            <el-button size="mini" type="danger" @click="changeAutomatic(scope.row,0)">Close All Automatic</el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="Action" width="110">
        <template slot-scope="scope">
          <div class="caozuo_btn">
            <el-button size="mini" type="primary" @click="seeDetail(scope.$index, scope.row)">Detail</el-button>
          </div>
          <div class="caozuo_btn">
            <el-button size="mini" type="danger" @click="handleEdit(scope.$index, scope.row)">Edit</el-button>
          </div>
          <div class="caozuo_btn">
            <el-button size="mini" type="warning" @click="changePwd(scope.row)">Reset</el-button>
          </div>
          <div class="caozuo_btn">
            <el-button size="mini" type="danger" @click="handleDel(scope.$index, scope.row)">Delete</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 详情 -->
    <el-dialog title="" :visible.sync="detailVisible" width="50%" @click='closeDialog("detail")'>
      <el-descriptions title="Business detail" :column="2" border style="padding-bottom:20px">
                <el-descriptions-item label="Callback url">{{detail_info.callback_url}}</el-descriptions-item>
        <el-descriptions-item label="Recharge commission">
          {{detail_info.reserved_com_rate?detail_info.reserved_com_rate+'%':''}}
        </el-descriptions-item>
        <el-descriptions-item label="Withdraw commission">
          {{detail_info.transaction_com_rate?detail_info.transaction_com_rate+'%':''}}
        </el-descriptions-item>
        <el-descriptions-item label="Withdraw fee">
          {{detail_info.transaction_fee?detail_info.transaction_fee:''}}
        </el-descriptions-item>
        <el-descriptions-item label="Save time">{{detail_info.save_time|timestampToTime}}</el-descriptions-item>
        <el-descriptions-item label="Income">{{detail_info.billed_cost}}</el-descriptions-item>
        <el-descriptions-item label="Income commission">{{detail_info.billed_commission}}</el-descriptions-item>
        <el-descriptions-item label="All income">{{detail_info.total_cost}}</el-descriptions-item>
        <el-descriptions-item label="Residual income">{{detail_info.sh_cost}}</el-descriptions-item>
        <el-descriptions-item label="Commission paid">{{detail_info.billed_commission}}</el-descriptions-item>
        <el-descriptions-item label="Residual commission">{{detail_info.sh_commission}}</el-descriptions-item>
        <el-descriptions-item label="Balance">{{detail_info.balance}}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>
    <el-dialog title="Reset password" :visible.sync="pwdVisible" width="35%" @click='closeDialog("pwd")'>
      <el-form :inline="true" label-width="150px" :model="pageparm_pwd">
        <el-form-item label="Name" prop="name">
          <el-input size="small" v-model="pageparm_pwd.name" disabled auto-complete="off" placeholder="name" clearable>
          </el-input>
        </el-form-item>
        <br />
        <el-form-item label="Password" prop="password">
          <el-input size="small" show-password v-model="pageparm_pwd.password" auto-complete="off"
            placeholder="password" clearable>
          </el-input>
        </el-form-item>
        <br />
        <el-form-item label="Repeat password" prop="re_password">
          <el-input size="small" show-password v-model="pageparm_pwd.re_password" auto-complete="off"
            placeholder="repeat password" clearable>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("pwd")'>Cancel</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="pwdForm('pageparm_pwd')">Save
        </el-button>
      </div>
    </el-dialog>
    <!-- Edit界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @click='closeDialog("edit")'>
      <el-form label-width="200px" :model="editForm" ref="editForm" :rules="rules">
        <el-form-item label="Name" prop="name">
          <el-input size="small" v-model="editForm.name" auto-complete="off" disabled placeholder="name" clearable
            style="width:300px">
          </el-input>
        </el-form-item>
        <el-form-item label="Description" prop="description">
          <el-input size="small" v-model="editForm.description" auto-complete="off" placeholder="description" clearable
            style="width:300px">
          </el-input>
        </el-form-item>
        <el-form-item label="Status" prop="state">
          <el-radio-group v-model="editForm.state">
            <el-radio :label="1" v-if="editForm.state==1">reviewed</el-radio>
            <el-radio :label="2">using</el-radio>
            <el-radio :label="3">disabled</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="Withdraw priority" prop="trans_level">
          <el-input style="width:300px" type="number" size="small" v-model="editForm.trans_level" auto-complete="off"
            placeholder="Withdraw priority，The higher the number, the higher the priority" clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="Recharge commission" prop="reserved_com_rate">
          <el-input style="width:300px" type="number" size="small" v-model="editForm.reserved_com_rate"
            auto-complete="off" placeholder="recharge commission" clearable>
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
        <el-form-item label="Withdraw commission" prop="transaction_com_rate">
          <el-input style="width:300px" type="number" size="small" v-model="editForm.transaction_com_rate"
            auto-complete="off" placeholder="withdraw commission" clearable>
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
        <el-form-item label="Withdraw fee" prop="transaction_fee">
          <el-input style="width:300px" size="small" type="number" v-model="editForm.transaction_fee"
            auto-complete="off" placeholder="withdraw fee" clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="Withdraw Judgment balance" prop="balance_limit">
          <el-radio-group v-model="editForm.balance_limit">
            <el-radio :label="1">Yes</el-radio>
            <el-radio :label="2" :disabled="Number(editForm.id) === 82">No</el-radio>
          </el-radio-group>
          <span v-if="Number(editForm.id) === 82" style="margin-left: 12px; color: #909399">DRC666 always checks the available balance.</span>
        </el-form-item>
        <el-form-item label="Deduct transaction fee" prop="deduct_transaction_fee">
          <el-radio-group v-model="editForm.deduct_transaction_fee">
            <el-radio :label="1">Yes</el-radio>
            <el-radio :label="2">No</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="Settle withdraw fee" prop="settle_withdraw_fee">
          <el-radio-group v-model="editForm.settle_withdraw_fee">
            <el-radio :label="1">Yes</el-radio>
            <el-radio :label="2">No</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="Transactions H5" prop="transactions_h5">
          <el-radio-group v-model="editForm.transactions_h5">
            <el-radio :label="1">Yes</el-radio>
            <el-radio :label="0">No</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="Cashier template" prop="cashier_template">
          <el-select v-model="editForm.cashier_template" size="small" style="width:300px">
            <el-option label="Default" value="default"></el-option>
            <el-option label="Electric charging · amber" value="ev-amber"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Display sort" prop="sort">
          <el-input style="width:300px" size="small" type="number" v-model="editForm.sort" auto-complete="off"
            placeholder="display sort（The larger the value, the higher the ranking）" clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="Super Agent" prop="agent_id">
          <el-select size="small" v-model="editForm.agent_id" clearable placeholder="Super Agent">
            <el-option v-for="item in agentList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Callback times" prop="callback_times">
          <el-input style="width:300px" size="small" type="number" v-model="editForm.callback_times" auto-complete="off"
            placeholder="Callback times" clearable>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>Cancel</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">Save
        </el-button>
      </div>
    </el-dialog>
    <!-- SIM card -->
    <el-dialog title="Select SIM card" :visible.sync="cardVisible" @click='closeDialog("card")' style="width:100%">
      <el-form :inline="true" :model="setcard" style="margin-top:-20px">
        <el-form-item label="">
          <el-input size="small" v-model="setcard.sms_user_name" placeholder="App name" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="cardSearch">Search</el-button>
        </el-form-item>
      </el-form>
      <el-table size="small" :data="card_list" highlight-current-row v-loading="loading"
        element-loading-text="Loading..." @selection-change="handleSelectionChange" ref="multipleTable">
        <el-table-column type="selection" width="55" :selectable="checkSelectable">
        </el-table-column>
        <el-table-column prop="number" label="Card number" width="100">
        </el-table-column>
        <el-table-column prop="name" label="Card name" width="140">
        </el-table-column>
        <el-table-column prop="operator_name" label="Operator" width="120">
        </el-table-column>
        <el-table-column prop="is_top" label="Status" width="90" align="center" sortable>
          <template slot-scope="scope">
            <el-link type="info" :underline="false" v-if="scope.row.state==1">using</el-link>
            <el-link type="danger" :underline="false" v-if="scope.row.state==2">disabled</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="sms_user_name" label="APP name" width="100">
        </el-table-column>
        <el-table-column prop="current_balance" label="Current balance" width="120">
        </el-table-column>
        <el-table-column prop="single_min" label="Single min" width="90">
        </el-table-column>
        <el-table-column prop="single_max" label="Single max" width="90">
        </el-table-column>
        <el-table-column prop="day_limit" label="Day limit" width="90">
        </el-table-column>
        <el-table-column prop="balance_max" label="Balance max" width="100">
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("card")'>Cancel</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitCard">Save
        </el-button>
      </div>
    </el-dialog>
    <!-- Card Details -->
    <el-dialog title="" :visible.sync="cardBalanceVisible" @click='closeDialog("cardBalance")' width="50%">
      <el-descriptions title="Card Details" :column="2" border style="padding-bottom:20px">
        <el-descriptions-item label="Number">{{cardBalance.number}}</el-descriptions-item>
        <el-descriptions-item label="Name">{{cardBalance.name}}</el-descriptions-item>
        <el-descriptions-item label="Single min">
          {{cardBalance.single_min?cardBalance.single_min:0}}-{{cardBalance.single_max?cardBalance.single_max:99999999}}
        </el-descriptions-item>
        <el-descriptions-item label="Day limit">
          {{'<'+(cardBalance.day_limit?cardBalance.day_limit:999999999)}} </el-descriptions-item>
            <el-descriptions-item label="Balance max">
              {{'<'+(cardBalance.balance_max?cardBalance.balance_max:999999999)}} </el-descriptions-item>
                <el-descriptions-item label="Cal balance">
                  {{cardBalance.cal_balance_amount}}
                </el-descriptions-item>
                <el-descriptions-item label="Balance0">
                  {{cardBalance.balance0_amount}}
                </el-descriptions-item>
                <el-descriptions-item label="Today recharge refund">
                  {{cardBalance.today_refund_amount}}
                </el-descriptions-item>
                <el-descriptions-item label="Today withdraw refund">
                  {{cardBalance.today_transaction_refund_amount}}
                </el-descriptions-item>
                <el-descriptions-item label="Start using">
                  {{cardBalance.start_time}}
                </el-descriptions-item>
                <el-descriptions-item label="Using time" v-if="cardBalance.use_time">
                  {{cardBalance.use_time.replace('天',' Days')}}
                </el-descriptions-item>
                <el-descriptions-item label="Recharge">
                  {{cardBalance.reserved.count}}|{{cardBalance.reserved.sum_amount}}
                </el-descriptions-item>
                <el-descriptions-item label="Withdraw：">
                  {{cardBalance.transaction.count}}|{{cardBalance.transaction.sum_amount}}
                </el-descriptions-item>
                <el-descriptions-item label="Description：">
                  <el-input size="small" v-model="cardBalance.desc" placeholder="Set description" clearable
                    @change="cardDescChange($event,cardBalance.id)">
                  </el-input>
                </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
    <!-- Edit card balance -->
    <el-dialog title="Edit card balance" :visible.sync="cardBalanceEditVisible" width="420px"
      @close="resetCardBalanceEdit">
      <el-form label-width="150px" :model="cardBalanceEditForm" ref="cardBalanceEditForm">
        <el-form-item label="Current balance">
          <el-input size="small" v-model="cardBalanceEditForm.current_balance" disabled></el-input>
        </el-form-item>
        <el-form-item label="New balance" required>
          <el-input size="small" type="number" min="0" step="0.01" v-model="cardBalanceEditForm.new_balance"
            placeholder="Enter new balance" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cardBalanceEditVisible=false">Cancel</el-button>
        <el-button size="small" type="primary" :loading="cardBalanceSaving" @click="submitCardBalanceEdit">Save</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    businessList,
    updateState,
    businessPwdChange,
    getCardList,
    cardSet,
    businessDel,
    setLogo,
    updateCardState,
    smsAppGetSocketId,
    updateAutoTrans,
    cardAttachList,
    cardDesc,
    cardRemoved,
    updateCardBalance,
    changeBusinessAutomatic,
  } from '../../api/apiFun'
  import {
    timestampToTime,
    uploadUrl,
    getCookie,
    cascaderChange,
  } from '@/utils/util';
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        operatorList: [],
        setcard: {
          country: '',
          card_ids: '',
          id: '',
          sms_user_name: ''
        },
        countryList: [],
        detailVisible: false,
        editFormVisible: false,
        loading: false, //是显示加载
        params: {
          page: 1,
          limit: 10,
          name: '',
          country: '',
          sms_user_name: '',
          card_number: '',
          operator_id:''
        },
        listData: [], //Business数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        editForm: {
          id: '',
          name: '',
          state: '',
          trans_level: 0,
          reserved_com_rate: 0,
          transaction_com_rate: 0,
          transaction_fee: 0,
          balance_limit: '',
          description: '',
          sort: '',
          transactions_h5: 0,
          cashier_template: 'default',
          agent_id: '',
          callback_times: 3,
          deduct_transaction_fee: '',
          settle_withdraw_fee: '',
        },
        // rules 表单验证
        rules: {
          state: [{
            required: true,
            message: 'Please set up status',
            trigger: 'blur'
          }],
          reserved_com_rate: [{
            required: true,
            message: 'Please set up recharge commission percentage',
            trigger: 'blur'
          }],
          transaction_com_rate: [{
            required: true,
            message: 'Please set up transaction_com_rate',
            trigger: 'blur'
          }],
          agent_id: [{
            required: true,
            message: 'Please set up agent_id',
            trigger: 'blur'
          }],
          callback_times: [{
            required: true,
            message: 'Please set up callback_times commission percentage',
            trigger: 'blur'
          }],
        },
        title: '',
        pageparm_pwd: {
          id: '',
          name: '',
          password: '',
          re_password: ''
        },
        pwdVisible: false,
        stateVisible: false,
        editState: {
          id: '',
          state: '',
        },
        cardVisible: false,
        editCard: {
          id: '',
          card_ids: '',
        },
        card_list: [],
        upload_url: uploadUrl(),
        upload_header: {
          Authorization: getCookie('dkh_token')
        },
        dialogImageUrl: '',
        dialogLogoVisible: false,
        detail_info: {},
        agentList: [],
        cardBalanceVisible: false,
        cardBalanceEditVisible: false,
        cardBalanceSaving: false,
        cardBalanceEditForm: {
          id: '',
          number: '',
          current_balance: '',
          new_balance: ''
        },
        cardBalance: {
          "id": 82,
          "number": "723321402",
          "name": "JEMAIYO RUTO",
          "operator_id": 1,
          "opencard_id": 1,
          "single_min": "",
          "single_max": "",
          "day_limit": "",
          "balance_max": "",
          "pin": "2580",
          "state": 1,
          "save_time": 1698238198,
          "sms_user_id": 69,
          "business_id": 1,
          "agent_id": "2580",
          "start_use_time": 1698232322,
          "card_type": 2,
          "day_amount": "0.00",
          "balance_amount": "0.00",
          "cal_balance_amount": "0.00",
          "balance0_amount": "0.00",
          "today_reserved_amount": "0.00",
          "today_transaction_amount": "0.00",
          "today_refund_amount": "0.00",
          "today_transaction_refund_amount": "0.00",
          "sms_user_name": "K-mercy-1",
          "socket_id": 0,
          "auto_trans": 0,
          "operator_name": "m-pesa",
          "operator_country": "Kenya",
          "start_time": "2023-10-25",
          "use_time": "4天",
          "reserved": {
            "count": 0,
            "sum_amount": "0.00"
          },
          "transaction": {
            "count": 0,
            "sum_amount": "0.00"
          }
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    filters: {
      timestampToTime: function (timestamp) {
        return timestampToTime(timestamp)
      },
    },
    created() {
      this.getdata(this.params)
      this.cardAttachList()
    },
    methods: {
      openCardBalanceEdit(row) {
        this.cardBalanceEditForm.id = row.id
        this.cardBalanceEditForm.number = row.number
        this.cardBalanceEditForm.current_balance = row.balance_amount
        this.cardBalanceEditForm.new_balance = row.balance_amounts
        this.cardBalanceEditVisible = true
      },
      resetCardBalanceEdit() {
        this.cardBalanceSaving = false
        this.cardBalanceEditForm = {
          id: '',
          number: '',
          current_balance: '',
          new_balance: ''
        }
      },
      submitCardBalanceEdit() {
        var newBalance = String(this.cardBalanceEditForm.new_balance).trim()
        if (!/^\d+(\.\d{1,2})?$/.test(newBalance)) {
          this.$message.error('The new balance must be a non-negative number with no more than two decimal places')
          return
        }
        var confirmText = 'Are you sure you want to change card ' + this.cardBalanceEditForm.number +
          ' balance from ' + this.cardBalanceEditForm.current_balance + ' to ' + Number(newBalance).toFixed(2) + '?'
        this.$confirm(confirmText, 'Confirm balance change', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          this.cardBalanceSaving = true
          updateCardBalance({
            id: this.cardBalanceEditForm.id,
            new_balance: newBalance
          }).then(res => {
            this.cardBalanceSaving = false
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: 'Balance updated successfully'
              })
              this.cardBalanceEditVisible = false
              this.getdata(this.params)
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          }).catch(() => {
            this.cardBalanceSaving = false
            this.$message.error('Failed to update balance, please try again later!')
          })
        }).catch(() => {})
      },
      operatorParamsChange(value) {
        var cascader = cascaderChange(value)
        this.params.operator_id = cascader[1]
      },
      changeAutomatic(row, auto_trans) {
        var t = ''
        if (auto_trans == 0) {
          t = '确定要关闭' + row.name + '的所有自动代付吗?'
        } else {
          t = '确定要开启' + row.name + '的所有自动代付吗?'
        }
        this.$confirm(t, 'Tips', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          var parameter = {
            id: row.id,
            name: row.name,
            auto_trans: auto_trans
          }
          this.loading = true
          changeBusinessAutomatic(parameter).then(res => {
            this.loading = false
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: 'Edit succeeded'
              })
              this.getdata(this.params)
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          }).catch(err => {
            this.loading = false
            this.$message.error('Failed, please try again later!')
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Cancel'
          });
        });
      },
      cardDescChange(desc, id) {
        cardDesc({
          desc,
          id
        }).then(res => {
          if (res.code == 400) {
            this.$message({
              state: 'info',
              message: res.msg
            })
          } else {
            this.getdata(this.params)
          }
        }).catch(err => {
          this.$message.error('Failed to get country, please try again later!')
        })
      },
      cardBalanceDetail(row) {
        this.cardBalanceVisible = true
        this.cardBalance = row
      },
      cardAttachList() {
        cardAttachList().then(res => {
          if (res.code == 400) {
            this.$message({
              state: 'info',
              message: res.msg
            })
          } else {
            this.countryList = res.datas.country_list
            this.operatorList = res.datas.operator_list
            this.agentList = res.datas.agent_list
          }
        }).catch(err => {
          this.$message.error('Failed to get country, please try again later!')
        })
      },
      checkSelectable(row, index) {
        return row.selected === 0
      },
      handleSelectionChange(val) {
        let card_ids = [];
        val.forEach(item => {
          card_ids.push(item.id)
        });
        this.editCard.card_ids = card_ids.join(',');
      },
      getAllMessage(id) {
        smsAppGetSocketId({
          id
        }).then(res => {
          if (!res.datas) {
            this.$message.error('This user is offline and cannot be retrieved')
          }
          this.global.send(JSON.stringify({
            type: 'admin_send',
            socket_id: res.datas
          }))
        }).catch(err => {
          this.$message.error('Failed to get SMS, please try again later!')
        })
      },
      updateAutoTrans(id, state) {
        var t = 'ConfirmEditAutomatic Status吗?'
        this.$confirm(t, 'Tips', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          var parameter = {
            id,
            state
          }
          this.loading = true
          updateAutoTrans(parameter).then(res => {
            this.loading = false
            if (res.code == 400) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.$message({
                type: 'success',
                message: 'Edit succeeded'
              })
              this.getdata(this.params)
            }
          }).catch(err => {
            this.loading = false
            this.$message.error('Edit failed, please try again later!')
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Cancel edit'
          });
        });
      },
      cardRemoved(id, number, business_id) {
        var t = 'Are you sure you want to remove card number: ' + number + '?'
        this.$confirm(t, 'Tips', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          var parameter = {
            id,
            business_id
          }
          this.loading = true
          cardRemoved(parameter).then(res => {
            this.loading = false
            if (res.code == 400) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.$message({
                type: 'success',
                message: 'Removed succeeded'
              })
              this.getdata(this.params)
            }
          }).catch(err => {
            this.loading = false
            this.$message.error('Removed failed, please try again later!')
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Cancel Removed'
          });
        });
      },
      // EditSIM cardStatus
      updateCardState(id, number, state) {
        var t = 'Confirm edit SIM card ' + number + ' status?'
        this.$confirm(t, 'Tips', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          var parameter = {
            id,
            state
          }
          this.loading = true
          updateCardState(parameter).then(res => {
            this.loading = false
            if (res.code == 400) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.$message({
                type: 'success',
                message: 'Edit succeeded'
              })
              this.getdata(this.params)
            }
          }).catch(err => {
            this.loading = false
            this.$message.error('Edit failed, please try again later!')
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Cancel edit'
          });
        });
      },
      seeDetail(index, row) {
        this.detail_info = row;
        this.detailVisible = true;
      },
      // Edit、增加页面Save方法
      submitForm(editData) {
        if (this.editForm.reserved_com_rate <= 0) {
          this.$message.error('Recharge commission percentage must be greater than 0！')
          return
        }
        if (this.editForm.transaction_com_rate <= 0) {
          this.$message.error('Withdraw commission percentage must be greater than 0！')
          return
        }
        this.loading = true
        this.$refs[editData].validate(valid => {
          if (valid) {
            setLogo(this.editForm).then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: 'Edit succeeded!'
                })
                this.getdata(this.params)
                this.loading = false
                this.editFormVisible = false
              } else {
                this.loading = false
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            }).catch(err => {
              this.loading = false
              this.$message.error('Failed, please try again later!')
            })
          } else {
            this.loading = false
            return false
          }
        })
      },
      //显示Edit界面
      handleEdit: function (index, row) {
        this.editFormVisible = true
        if (row != undefined && row != 'undefined') {
          this.title = 'Edit'
          this.editForm.id = row.id
          this.editForm.name = row.name
          this.editForm.description = row.description ? row.description : ''
          this.editForm.sort = row.sort
          this.editForm.state = row.state
          this.editForm.trans_level = row.trans_level ? row.trans_level : 0
          this.editForm.reserved_com_rate = row.reserved_com_rate ? row.reserved_com_rate : 0
          this.editForm.transaction_com_rate = row.transaction_com_rate ? row.transaction_com_rate : 0
          this.editForm.transaction_fee = row.transaction_fee ? row.transaction_fee : 0
          this.editForm.balance_limit = Number(row.id) === 82 ? 1 : (row.balance_limit ? row.balance_limit : '')
          this.editForm.transactions_h5 = row.transactions_h5 ? row.transactions_h5 : 0
          this.editForm.cashier_template = row.cashier_template || 'default'
          this.editForm.agent_id = row.agent_id ? row.agent_id : ''
          this.editForm.callback_times = row.callback_times ? row.callback_times : 3
          this.editForm.deduct_transaction_fee = row.deduct_transaction_fee ? row.deduct_transaction_fee : ''
          this.editForm.settle_withdraw_fee = row.settle_withdraw_fee ? row.settle_withdraw_fee : ''
        }
      },
      handleDel(index, row) {
        this.$confirm('Are you sure you want to delete?', 'Tips', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          businessDel({
            id: row.id,
            name: row.name,
          }).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: 'successfully deleted!'
              })
              this.getdata(this.params)
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          }).catch(err => {
            this.$message.error('Deletion failed, please try again later!')
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Cancelled delete'
          })
        })
      },
      submitCard() {
        this.loading = true
        cardSet(this.editCard).then(res => {
          this.loading = false
          if (res.code == 400) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.getdata(this.params)
            this.$message({
              type: 'success',
              message: 'Edit succeeded'
            })
            this.cardVisible = false

          }
        }).catch(err => {
          this.loading = false
          this.$message.error('Edit failed, please try again later!')
        })
      },
      setCard(row) {
        this.card_list = [];
        this.setcard.country = row.country
        this.setcard.card_ids = row.card_ids
        this.setcard.id = row.id
        this.getCardList()
        this.editCard.id = row.id
        this.editCard.card_ids = row.card_ids
        this.cardVisible = true
      },

      cardSearch() {
        this.getCardList()
      },

      changeState(row) {
        this.editState.id = row.id
        this.editState.state = row.state
        this.stateVisible = true
      },
      submitState() {
        this.loading = true
        updateState(this.editState).then(res => {
          this.loading = false
          if (res.code == 400) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.getdata(this.params)
            this.$message({
              type: 'success',
              message: 'Edit succeeded'
            })
            this.stateVisible = false

          }
        }).catch(err => {
          this.loading = false
          this.$message.error('Edit failed, please try again later!')
        })
      },
      // Reset密码
      pwdForm(editData) {
        this.loading = true
        businessPwdChange(this.pageparm_pwd).then(res => {
          this.loading = false
          this.pwdVisible = false
          if (res.code == 200) {
            this.getdata(this.params)
            this.$message({
              type: 'success',
              message: 'Password reset successful!'
            })
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        }).catch(err => {
          this.editFormVisible = false
          this.loading = false
          this.$message.error('Password reset failed, please try again later!')
        })
      },
      changePwd(row) {
        this.pageparm_pwd.id = row.id
        this.pageparm_pwd.name = row.name
        this.pwdVisible = true
      },

      closeDialog(type) {
        if (type == 'state') {
          this.stateVisible = false
        }
        if (type == 'card') {
          this.cardVisible = false
        }
        if (type == 'detail') {
          this.detailVisible = false
        }
        if (type == 'edit') {
          this.editFormVisible = false
        }
        if (type == 'cardBalance') {
          this.cardBalanceVisible = false
        }
      },
      // 获取Business list
      getdata(parameter) {
        this.loading = true
        businessList(parameter).then(res => {
          this.loading = false
          if (res.code == 400) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.datas.list
            // 分页赋值
            this.pageparm.currentPage = this.params.page
            this.pageparm.pageSize = this.params.limit
            this.pageparm.total = res.datas.count
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('Failed to obtain business list, please try again later!')
        })
      },

      getCardList() {
        getCardList({
          country: this.setcard.country,
          card_idstr: this.setcard.card_ids,
          id: this.setcard.id,
          sms_user_name: this.setcard.sms_user_name,
        }).then(res => {
          if (res.code == 400) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.card_list = res.datas.list
            this.$nextTick(() => {
              this.$refs.multipleTable.clearSelection();
              res.datas.list.forEach(item => {
                if (item.selected == 1) {
                  this.$refs.multipleTable.toggleRowSelection(item);
                }
              })
            })
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('Failed to get SIM card list, please try again later!')
        })
      },
      // 分页插件事件
      callFather(parm) {
        this.params.page = parm.currentPage
        this.params.limit = parm.pageSize
        this.getdata(this.params)
      },
      // Search事件
      search() {
        this.params.page = 1
        this.getdata(this.params)
      },
    }
  }

</script>
<style lang="">
  .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
    background-color: #409EFF !important;
    border-color: #409EFF !important;
  }
</style>
<style scoped>
  .business-search {
    margin-top: 20px;
  }

  .businessRole {
    width: 100%;
  }

  .caozuo_btn {
    margin-top: 5px;
    display: flex;
    justify-content: flex-start;
  }

  .card-balance-edit {
    margin-left: 6px;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/views/business/business_lists.vue